<template>
  <v-dialog v-model="dialog" persistent width="750">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-toolbar color="#7e5ec2">
        <span class="material-symbols-outlined"> </span>
        <p class="tituloCard">Reprogramar vacaciones</p>
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <h4 class="texto">
                  <strong class="titulo">Número:</strong>
                  {{ this.form.secuencia }}
                </h4>
              </v-flex>
              <v-flex xs12>
                <h4 class="texto">
                  <strong class="titulo">Nombre:</strong>
                  {{ this.form.nombres }}
                </h4>
              </v-flex>

              <v-flex xs12>
                <h4 class="subtitulo"><strong>Detalle papeleta</strong></h4>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  :items="lista_papeleta"
                  class="elevation-1"
                  hide-actions
                  :headers="headers"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">{{ props.item.fecha_desde }}</td>
                    <td class="text-xs-center">{{ props.item.fecha_hasta }}</td>

                    <td class="text-xs-center">{{ props.item.total_dias }}</td>
                    <td class="text-xs-center">{{ props.item.estado }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-flex xs12>
              <h4 class="subtitulo"><strong>Seguimiento papeleta</strong></h4>
            </v-flex>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  :items="lista_detalle"
                  class="elevation-1"
                  hide-actions
                  :headers="headers2"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">
                      {{ props.item.fecha_registro }}
                    </td>
                    <td class="text-xs-center">{{ props.item.estado }}</td>
                    <td class="text-xs-center">{{ props.item.usuario }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex md12>
                <v-textarea
                  v-model="form.justificacion_rechazo"
                  @input="validacionBoton()"
                  class="v_card"
                  rows="1"
                  label="Justificación del rechazo"
                  background-color="rgba( 117, 109, 194 ,0.4)"
                  :rules="$validate(['required'])"
                  required
                  outline
                  success
                  clearable
                >
                </v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="rgba(255,17,0,0.6)"
            :disabled="bandera_boton"
            @click.prevent="reprogramar()"
            ><v-icon>clear</v-icon>
            Reprogramar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,

      form: {
        funcionario: {
          nombre: ""
        }
      },
      //url: 'vCronoVacass',
      valid: false,
      loading: false,
      estado_vacacion: [],
      bandera_boton: true,
      nombre: null,
      fecha_ingreso: null,
      fecha_desde: "",
      fecha_hasta: "",
      persona: null,
      saldo: null,
      datos_usuario: null,
      id: null,
      lista_papeleta: [],
      lista_detalle: [],
      headers: [
        { text: "Fecha salida", sortable: false, align: "center" },
        { text: "Fecha fin", sortable: false, align: "center" },

        { text: "Dias", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" }
      ],
      headers2: [
        { text: "Fecha registro", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" },
        { text: "Usuario", sortable: false, align: "center" }
      ]
    };
  },
  async mounted() {
    this.$bus.$on("openDialogReprogramarJefeSup", async item => {
      this.form = item;
      this.form.id_vacacion_programada = parseInt(
        this.form.id_vacacion_programada
      );
      // Obtnemos el correo del servidor seleccionado
      this.datos_usuario = await this.obtieneDatosPersona(this.form.id_persona);
      this.cargarTablaPapeleta();
      this.dialog = true;
      await this.cargarSeguimiento();
    });
  },

  methods: {
    close() {
      this.form = {
        funcionario: {
          nombre: ""
        }
      };
      this.lista_papeleta = [];
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogReprogramarJefeSup");
      this.dialog = false;
    },
    cargarTablaPapeleta() {
      this.lista_papeleta.push(this.form);
    },
    validacionBoton() {
      if (this.form.justificacion_rechazo) {
        this.bandera_boton = false;
      } else {
        this.bandera_boton = true;
      }
    },
    async obtieneDatosPersona(id_persona) {
      try {
        let usuario = null;
        let respuesta = await this.$service.graphql({
          query: `
          query{
              runQuery(consulta:"select u.correo,u.nombre_usuario,up.id_persona,u.id as id_usuario,p.ap_paterno,p.ap_materno,p.nombres from seguridad.usuario_persona up join seguridad.usuario u  on up.id_usuario =u.id join persona.persona p on up.id_persona =p.id  where up.id_persona =  ${id_persona}"){
                respuesta
              }
            }
          `
        });
        respuesta = respuesta.runQuery.respuesta;
        if (respuesta.length > 0) {
          usuario = respuesta[0];
        }
        return usuario;
      } catch (error) {
        console.log(error);
      }
    },
    async cargarSeguimiento() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
			query{
				runQuery(consulta:"select * from vacaciones.v_seguimiento_vaca_progra vsvp  where vsvp.id_vaca_progra =${this.form.id_vacacion}"){
					respuesta
				}
				}
			`
        });
        respuesta = respuesta.runQuery.respuesta;
        let lista_seguimiento = [];
        if (this.form.tipo == "P") {
          respuesta.forEach(element => {
            let elemento = element;
            if (
              elemento.id_estado != 22 &&
              elemento.id_estado != 54 &&
              elemento.id_estado != 51 &&
              elemento.id_estado != 66 &&
              elemento.id_estado != 74 &&
              elemento.id_estado != 73 &&
              elemento.id_estado != 72
            ) {
              lista_seguimiento.push(elemento);
            }
          });
          this.lista_detalle = lista_seguimiento;
        } else {
          this.lista_detalle = respuesta;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async reprogramar() {
      let respuesta;
      let resps = [];
      let correcto;
      let user = this.$storage.get("user");
      let id_funcionario = user.id;
      this.form.motivo = "0 motivo";

      this.loading = true;
      try {
        respuesta = await this.$service.graphql({
          query: `
									 query{
                                      runQuery(consulta:"select vacaciones.fn_envia_a_reprogramar_vacacion(${this.form.id_vacacion},56,${user.id},'${this.form.justificacion_rechazo}')"){
                                        respuesta
                                      }
                                    }
								`
        });
        respuesta =
          respuesta.runQuery.respuesta[0].fn_envia_a_reprogramar_vacacion;
        resps = respuesta.split("|");
        correcto = resps[0];

        if (correcto === "1") {
          //enviamos el correo al funcionario:
          if (this.datos_usuario) {
             var mensaje = `
              <h1>NOTIFICACIÓN - RECHAZO DE PROGRAMACIÓN </h1>
              Estimado(a): ${this.datos_usuario.nombres} ${this.datos_usuario.ap_paterno} ${this.datos_usuario.ap_materno} <br>
              Su programación fue rechazada por : ${this.form.justificacion_rechazo}, por lo tanto debe reprogramar su vacación.`;
            await this.$service.sendEmail({
              correo: this.datos_usuario.correo,
              asunto: `NOTIFICACIÓN - RECHAZO DE PROGRAMACIÓN `,
              mensaje: mensaje.replace(/<[^>]+>/g, ""),
              html: mensaje
            });
          } else {
            this.$message.info(
              "No se notifico por correo ya que el servidor no posee un correo registrado"
            );
          }
          this.$confirm("La solicitud fué enviada a reprogramar", () => {
            this.loading = false;
            this.close();
          });
        } else {
          this.$confirm(resps[1], () => {
            this.loading = false;
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style>
.titulo {
  font-size: 1.07em;
  color: rgb(20, 7, 84);
  font-weight: bold;
}
.texto {
  font-size: 1.07em;
  color: rgb(20, 7, 84);
}
.subtitulo {
  font-size: 1.35em;
  color: rgb(20, 7, 84);
  font-weight: bolder;
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
}
.cabecera {
  background-color: rgba(20, 7, 84, 0.35);
  font-size: 1.5em;
  color: rgba(20, 7, 84);
  font-weight: bolder;
}
.cabecera_rechaza {
  background-color: rgba(20, 7, 84, 0.301);
  font-size: 1.5em;
  color: rgb(20, 7, 84);
  font-weight: bolder;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_uso/dialogs/ReprogramarJefeSup.vue